import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TeamsPhoneNumberAssignmentFieldConfig } from '../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class MicrosoftPhoneNumberAssignmentsFieldConfigResource {
  private http = inject(HttpClient);

  get(tenantId: string | number, lineUri: string): Observable<TeamsPhoneNumberAssignmentFieldConfig> {
    return this.http.get<TeamsPhoneNumberAssignmentFieldConfig>(
      `/services/microsoft/field-configs/tenants/${tenantId}/teams-phone-number-assignments/${encodeURIComponent(lineUri)}`,
    );
  }
}
